export default {
	huanyinghuilai: 'Welcome Back',
	wodezhanghu: 'My Account',
	gerenxinxi: 'Personal Information',
	jiatingyupengyou: 'Family and Friends',
	fukuanshijian: 'Payment Time',
	fukuanfangshi: 'Payment Method',
	fukuanjine: 'Payment Amount',
	genggaimima: 'Change Password',
	quebaoxinxizhengque: 'Please ensure that all the information is correct. All Title(s) and Passenger name(s) must be entered exactly as shown on your passport(s) or other valid travel document(s).',
	zhuxiao: 'Log Out',
	quedingyaodengchuma: 'Are you sure you want to log out？',
	tuichuchenggong: 'Exit Successfully!',
	nishifeixingchangkema: 'Are you part of a frequent flyer program?',
	lijitianjianindejiarenhepengyou: 'Add your family and friends now',
	tianjianindepengyou: 'Add your friends and family’s details for a faster booking process.',
	xinzeng: 'New Add',
	lijitianjiaka: 'Add Card Now',
	tianjiaka: 'Add card for a faster booking process.',
	bianji: 'Edit',
	shanchu: 'Delete',
	querenshanchuchengkexinxime: 'Are you sure to delete the passenger information?'
};
